import React from "react";

// Shared layout for Privacy and Terms.
const Legal = ({ title, intro, blocks }) => (
  <div className="page">
    <section className="phero">
      <div className="wrap">
        <span className="eyebrow">Legal</span>
        <h1 className="h-xl" style={{ maxWidth: "14ch" }}>{title}</h1>
        <p className="lead" style={{ marginTop: 20 }}>{intro}</p>
      </div>
    </section>
    <section className="sec-tight">
      <div className="wrap" style={{ maxWidth: 820 }}>
        {blocks.map(([h, b]) => (
          <div className="reveal" key={h} style={{ marginBottom: 34 }}>
            <h2 className="h-md" style={{ marginBottom: 12 }}>{h}</h2>
            <p className="lead" style={{ fontSize: "1rem" }}>{b}</p>
          </div>
        ))}
        <p className="muted" style={{ fontSize: ".88rem", marginTop: 40 }}>
          Placeholder wording for layout purposes. Replace with content approved by your legal adviser before launch.
        </p>
      </div>
    </section>
  </div>
);

export default Legal;
